import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useKeycloakAuth } from "@/hooks/useKeycloakAuth";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { MaintenanceMode } from "@/components/MaintenanceMode";
import {
  MAINTENANCE_MODE,
  MAINTENANCE_TITLE,
  MAINTENANCE_DESCRIPTION,
} from "@/config/maintenance";
import { loginMusa } from "@/config/auth";
import { LogIn } from "lucide-react";
import { Button, Text } from "@musa.tech/design-system";
import logo from "../assets/logo-musa-dark.png";
import { getLandingRouteFromToken } from "@/utils/landingRoute";

/**
 * Rota /login/musa — autenticação de usuários internos via Realm Musa no Keycloak.
 * Usa o mesmo client do .env; o redirect_uri é /login-redirect/musa.
 */
const LoginMusa = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading: authLoading } = useKeycloakAuth();

  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      navigate(getLandingRouteFromToken());
    }
  }, [isAuthenticated, authLoading, navigate]);

  useEffect(() => {
    if (!authLoading && !isAuthenticated && !MAINTENANCE_MODE) {
      const timer = setTimeout(() => {
        loginMusa();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [authLoading, isAuthenticated]);

  const handleLogin = () => {
    loginMusa();
  };

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
      </div>
    );
  }

  if (MAINTENANCE_MODE) {
    return (
      <MaintenanceMode
        title={MAINTENANCE_TITLE}
        description={MAINTENANCE_DESCRIPTION}
      />
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <Card className="w-full max-w-md shadow-2xl backdrop-blur-sm bg-white/90 border border-white/20">
        <CardHeader className="text-center space-y-6 pb-8">
          <img src={logo} alt="Musa Logo" className="mx-auto w-40" />
          <Text variant="h2" className="text-gray-700">
            Portal Musa — Login interno
          </Text>
          <Text variant="body" className="text-gray-600">
            Acesso com Realm Musa (Keycloak)
          </Text>
        </CardHeader>
        <CardContent className="space-y-6 pb-8">
          <Button className="w-full" onClick={handleLogin}>
            <LogIn className="mr-2 h-5 w-5" /> Entrar com Keycloak (Musa)
          </Button>
          <p className="text-xs text-center text-gray-500">
            Você será redirecionado para o login do Realm Musa
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginMusa;
